import { axiosInstance } from './api'

import { AllDataToModerate } from 'types/moderation'

export const moderateApi = {
  getConsents() {
    return axiosInstance.get<AllDataToModerate>('publisher/consents')
  },
  approve(id: number, approved: boolean) {
    return axiosInstance.post(`publisher/consents/${id}`, { approved })
  },
  check(ad_place_id: number) {
    return axiosInstance.head(`publisher/consents/${ad_place_id}`)
  },
}
